import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserDto } from '@app/store/shared/models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';

@Service()
export class HttpService {
    private httpClient = inject(HttpClient);

    /**
     * There is no dedicated session route, so this reuses `me`: a 2xx means a session is live.
     * `session` keeps only the permissions — the user itself is handed to `profile` by its bridge.
     */
    getSession(): Observable<User> {
        return this.httpClient.get<ApiResponse<UserDto>>('me').pipe(mapDto(({ data }) => new User(data)));
    }
}
